import React from 'react'

import SlideInner from '../SlideInner/SlideInner'
import styles from './LandingToursOfDuty.scss'
import {
    LANDING_TOURS_OF_DUTY_HEADER,
    LANDING_TOURS_OF_DUTY_MESSAGE1,
    LANDING_TOURS_OF_DUTY_MESSAGE2,
} from './translations'

const LandingToursOfDuty = () => {
    return (
        <SlideInner
            title={LANDING_TOURS_OF_DUTY_HEADER}
            description={[LANDING_TOURS_OF_DUTY_MESSAGE1, LANDING_TOURS_OF_DUTY_MESSAGE2]}
        >
            <div className={styles.imageContainer}/>
        </SlideInner>
    )
}

export default LandingToursOfDuty


// WEBPACK FOOTER //
// ./containers/Landing/components/LandingToursOfDuty/LandingToursOfDuty.jsx